<script>
  export let color;
  export let isCounting = false;
  export let count = "";

  import { getColorName } from "../helpers/strings";
</script>

<div
  class="notification class-title has-background-{color} is-flex is-flex-direction-column"
>
  {#if isCounting}
    <div class="vertical-center has-text-centered">
      <span class="is-capitalized is-size-3 has-text-light">
        {count}
      </span>
    </div>
  {/if}
  <div class="vertical-center has-text-centered">
    <span class="is-capitalized is-size-3 is-family-monospace has-text-light">
      {#if isCounting}
        ➡️
      {/if}
      {getColorName(color)}
    </span>
  </div>
</div>
